import { defineComponent as _defineComponent } from 'vue'
import { AbLink, AbSection, AbContainer } from '../../../ui';
import BlogSectionTextImageCard from './BlogSectionTextImageCard.vue';
import { Spacing } from '../../../../helpers/shared-props';

interface NewsCard {
  title: string;
  date: string;
  slug?: string;
  url?: string;
  image: {
    path: string;
    alt?: string;
  };
}

interface Props {
  data: {
    id?: string;
    news: NewsCard[];
    download?: boolean;
    downloadText?: string;
    spacing?: Spacing;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionTextImage',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: {
    id?: string;
    news: NewsCard[];
    download?: boolean;
    downloadText?: string;
    spacing?: Spacing;
  };
};


const getUrl = (item: NewsCard) => {
  if (item.url && !props.data.download) {
    return item.url;
  }
  return item.slug;
};

return { __sfc: true,props, getUrl, AbLink, AbSection, AbContainer, BlogSectionTextImageCard }
}

})